import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";
import { getStoryDetails } from "../../../../redux/actions/campaignActions";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Editstory = () => {
  const [file, setFile] = useState({
    files: "",
    preview:
      "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
  });
  const [profile_pic_name, setProfile_pic_name] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const id = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storyView = useSelector((state) => state.storyView);
  const { story } = storyView;

  let token = localStorage.getItem("accessToken");

  useEffect(() => {
    dispatch(getStoryDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (story?.data?.profile_pic !== null) {
      setFile({
        files: story?.data?.profile_pic,
        preview: story?.data?.profile_pic,
      });
    } else {
      setFile({
        files: "",
        preview:
          "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
      });
    }
  }, [story]);

  useEffect(() => {
    if (story) {
      setValue("firstname", story?.data?.firstname);
      setValue("lastname", story?.data?.lastname);
      setValue("email", story?.data?.email);
      setValue("story", story?.data?.profile_story);
      setProfile_pic_name(story?.data?.profile_pic);
    }
  }, [story]);

  useEffect(() => {
    if (storyView) {
      if (storyView?.loading !== undefined) {
        setLoading(storyView?.loading);
      }
    }
  }, [storyView]);

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const profileImage = async (e) => {
    const baseUrl = process.env.REACT_APP_API + "admin/update-userprofilepic";
    const selected = e.target.files[0];
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      let formData = new FormData();
      setLoading(true);
      formData.append("user_id", id.storyId);
      formData.append("file", selected);
      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      };
      const res = await axios
        .patch(baseUrl, formData, axiosConfig)
        .then((response) => {
          setFile({
            files: response?.data?.data?.document_name,
            preview: response?.data?.data?.document_name,
          });
          setLoading(false);
          setError(false);
        });
    } else {
      setError(true);
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    let formData = new FormData();
    for (let dataKey in data) {
      if (dataKey === "preview") {
        for (let previewKey in data[dataKey]) {
          formData.append(`preview[${previewKey}]`, data[dataKey][previewKey]);
        }
      } else {
        formData.append(dataKey, data[dataKey]);
      }
    }
    formData.append("success_story_id", id.storyId);
    if (file.files !== "" && profile_pic_name == "") {
      formData.append("profile_pic", file?.files);
    } else if (file.files !== "" && profile_pic_name !== "") {
      formData.append("profile_pic", file?.files);
      formData.append("profile_pic_name", profile_pic_name);
    }
    // formData.append("profile_pic", file?.files);
    // formData.append("profile_pic_name", profile_pic_name);
    try {
      const res = await axios({
        method: "PATCH",
        url: process.env.REACT_APP_API + "update-success-story",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });

      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/success-story");
      }
    } catch (error) {
      if (error.response !== "" && error.response.data.message !== "") {
        setLoading(false);
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Edit New story</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <div className="imgChange-div">
                <img src={ImgChangeIcon} alt="" className="imgChangeIcon" />
              </div>
              <input
                type="file"
                name="file"
                accept="image/png , image/jpeg"
                title=""
                className="profile-pic-select"
                onChange={(e) => profileImage(e)}
              />

              <img
                src={file ? file.preview : story?.data?.profile_pic}
                alt=""
                className="setting-profile"
              />
            </div>

            {error && (
              <span style={{ color: "red" }}>
                Please upload file in jpg,jpeg and png format
              </span>
            )}
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  {...register("firstname", {
                    required: "First name is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter First Name"
                />
                {errors.firstname && (
                  <div className="invalid-feedback">
                    {errors.firstname.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  {...register("lastname", {
                    required: "Last name is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Last Name"
                />
                {errors.lastname && (
                  <div className="invalid-feedback">
                    {errors.lastname.message}
                  </div>
                )}
              </div>

              <div className="formInput">
                <label>Description</label>

                <textarea
                  type="text"
                  name="story"
                  className="description-textarea"
                  {...register("story", {
                    required: "Description is required",
                  })}
                  cols="43"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.story && (
                  <div className="invalid-feedback text-left">
                    {errors.story.message}
                  </div>
                )}
              </div>
              <div className="formInput"></div>

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editstory;
